export default new class {

  /**
   *
   * @param linkDef
   * @returns {{idStructure: *, page: *}}
   */
  getRouteParams (linkDef) {
    let params = {

      // parametry v url
      page:        linkDef.Field,
      idStructure: linkDef.idtEntityStructureFrom
    }

    return { name: 'PageDynamicRowEditor', params: params }
  }

}
